import React from "react";
import { Grid, Link, Typography } from "@material-ui/core";
import { LogoEscudo, LogoRenovacion } from '../img'

export class Footer extends React.Component {

  render () {
    return(
      <React.Fragment>
        <Grid
          container
          alignItems="center"
          spacing={8}
          direction={"row"}
          className={"footer"}>
          <Grid item xs={6} sm={'auto'} md={'auto'} lg={'auto'} xl={'auto'} className="logoEscudo" >
            <img src={LogoEscudo} alt="escudo-uach" />
          </Grid>
          <Grid item xs={true} sm={true} md={true} lg={true} xl={true} className="copyright">
            <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="flex-end">
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="politics">
                <Typography>Departamento de Atención a Usuarios 4391816 o ext. 1716</Typography>
                <Typography><strong>Universidad Autónoma de Chihuahua</strong></Typography>
                <Typography>UACH Centro Interior Universitario, Campus 1</Typography>
                <Typography>Chihuahua, Chih., México</Typography>
                <Typography className="year">2021 © Todos los derechos reservados   <span>|</span> <Link href="https://uach.mx/visitantes/privacidad-y-politicas-institucionales-para-el-uso-de-la-pagina-web/" target="_blank">Privacidad y Políticas</Link></Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js